import React from 'react'

import StyledResponsiveImage from './styles'
import { Props } from './types'

const ResponsiveImage: React.FC<Props> = (props): React.ReactElement => <StyledResponsiveImage {...props} />

export * from './types'

export default ResponsiveImage
